import React from 'react';
import { Bill } from '../../../models/Factura';
import { Receptor, SerieTracker } from '../../../models/Catalogos';
import AutoComplete from '../../Forms/Autocomplete';
import Input from '../../Forms/Input';
import Select from '../../Forms/Select';
import SwitchCheckbox from '../../Forms/SwtichCheckbox';
import { FechaOptions, GENERIC_RFC, REGIMEN_OPT } from '../constants/factura.options';

export type ReceptorProperty = 'nombre' | 'rfc' | 'usoCFDI' | 'email' | 'regimen' | 'zip';
export type ComprobanteProperty = 'formaPago' | 'metodoPago' | 'serie' | 'folio' | 'fecha';

interface FacturaReceptorProps {
    cfdi: Bill;
    validRequested: boolean;
    invalidUsoCfdi: string;
    asGlobal: boolean;
    fechaOptions: FechaOptions;
    receptorOptions: Receptor[];
    trackerOptions: SerieTracker[];
    usosCFDI: { value: string, label: string, forRegimen: string[] }[];
    // Emitters
    onAsGlobalChange: (asGlobal: boolean) => void;
    onReceptorChange: (property: ReceptorProperty) => (value: string) => void;
    onReceptorAutofill: (receptorAsString: string) => void;
    onComprobanteChange: (property: ComprobanteProperty) => (value: any) => void;
}

function FacturaReceptor({
    cfdi,
    validRequested,
    invalidUsoCfdi,
    asGlobal,
    fechaOptions,
    receptorOptions,
    trackerOptions,
    usosCFDI,
    onAsGlobalChange,
    onReceptorChange,
    onReceptorAutofill,
    onComprobanteChange }: FacturaReceptorProps) {

    const trackerToOptions = trackerOptions.map(t => ({ label: t.serie, value: t.serie, template: <p className="_serie">{t.serie} <span>(folio: {t.folio})</span></p> }));
    const receptorNameOptions = receptorOptions.map(r => ({ label: r.name, value: JSON.stringify(r), template: <div><p className="_big">{r.name}</p><p className="_small">{r.rfc}</p></div> }));
    const receptorRFCOptions = receptorOptions.map(r => ({ label: r.rfc, value: JSON.stringify(r), template: <div><p className="_big">{r.rfc}</p><p className="_small">{r.name}</p></div> }));

    const usosCFDIOptions = usosCFDI.map((u) => {
        const disabled = !u.forRegimen.length ? false : !u.forRegimen.includes(cfdi.receptor.regimen);
        return Object.assign({}, u, { disabled });
    });

    const isGenericRfc = cfdi.receptor?.rfc === GENERIC_RFC;

    return (
        <div>
            <h4>Receptor de CFDI</h4>
            <div className="card table">
                <div className="cardBody">
                    <div className='row three  lg-two xxs-one cfdiBase xs-gap-compressed'>
                        <Select label="Fecha de factura" value={cfdi.fecha} options={fechaOptions} onChange={onComprobanteChange('fecha')} />
                    </div>
                    <div className="row three lg-two xxs-one cfdiBase xs-gap-compressed">
                        <AutoComplete label="Nombre" hasError={validRequested && !cfdi.receptor.nombre} value={cfdi.receptor.nombre} placeholder="Razón social de receptor" type="text"
                            noChangeOnSelect={true} options={receptorNameOptions} forcePropsValue={true} onChange={onReceptorChange('nombre')} onSelect={onReceptorAutofill} />

                        <AutoComplete label="RFC" hasError={validRequested && !cfdi.receptor.rfc} value={cfdi.receptor.rfc} placeholder="RFC de receptor" type="text"
                            noChangeOnSelect={true} options={receptorRFCOptions} forcePropsValue={true} onChange={onReceptorChange('rfc')} onSelect={onReceptorAutofill} />

                        {
                            isGenericRfc ?
                                <div className='row centerY globalSwitch' >
                                    <SwitchCheckbox value={asGlobal} onChange={onAsGlobalChange} />
                                    <p className='centerY'>
                                        Es Factura Global
                                    </p>
                                </div>
                                :
                                <div className='row lg-hidden' />
                        }
                        <Select label="Régimen" hasError={validRequested && !cfdi.receptor.regimen} value={cfdi.receptor.regimen} onChange={onReceptorChange('regimen')} placeholder="Régimen fiscal del receptor" options={REGIMEN_OPT} disabled={isGenericRfc} />

                        <Select label={'Uso CFDI'} hasError={(validRequested && !cfdi.receptor.usoCFDI) || !!invalidUsoCfdi} errorLabel={invalidUsoCfdi} value={cfdi.receptor.usoCFDI} options={usosCFDIOptions} onChange={onReceptorChange('usoCFDI')} />
                        <Input label="Código Postal" hasError={validRequested && ((cfdi.receptor.zip || '').length !== 5)} value={cfdi.receptor.zip} onChange={onReceptorChange('zip')} type="text" placeholder="Codigo Postal Domicilio Fiscal" disabled={isGenericRfc} />

                        <AutoComplete label="Serie de factura" hasError={validRequested && !cfdi.serie} value={cfdi.serie} onChange={onComprobanteChange('serie')} type="text" placeholder="Serie Factura"
                            noChangeOnSelect={true} options={trackerToOptions} forcePropsValue={true} onSelect={onComprobanteChange('serie')} />

                        <Input label="Folio" hasError={validRequested && !cfdi.folio} value={cfdi.folio} onChange={onComprobanteChange('folio')} type="text" placeholder="Folio Factura" />
                        <Input label="Correo (Opcional, se envia automáticamente)" value={cfdi.receptor.email} onChange={onReceptorChange('email')} type="text" placeholder="Email" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FacturaReceptor;
